import React, {
  forwardRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  EnrichementTemplate,
  IntegrationTemplate,
  LinkedinTemplate,
} from "../common/Templates/Templates";
import TemplateSettings from "../common/Templates/TemplateSettings";
import {
  createWorkflow,
  getTemplates,
  updateWorkflowActivationState,
} from "../../../services/api/workflows.api";
import { WorkflowContext } from "../store/workflow.store";
import actions from "../store/workflow.actions";
import { ModalMessage, PreLoader } from "../../../components";
import { checkPermission } from "../../../services/utils";
import { toast, ToastContainer } from "react-toastify";
import { FormattedMessage } from "react-intl";
const MenuBar = forwardRef(({ createWorkflow }, ref) => {
  const [name, setName] = useState("");
  return (
    <div className="create-workflow-menubar">
      <div className="workflow-name-field">
        <FormattedMessage id={"workflow.enterWorkflowName"}>
          {(placeholder) => (
            <input
              type="text"
              onChange={(e) => setName(e.target.value)}
              placeholder={placeholder}
              required
              ref={ref}
            />
          )}
        </FormattedMessage>
      </div>
      <div className="save-publish-ui">
        <a href="#" className="btn1" onClick={() => createWorkflow(name)}>
          <FormattedMessage id={"workflow.saveAndPublish"} />
        </a>
      </div>
    </div>
  );
});

function WorkflowTreeWrapper({ children }) {
  return (
    <div className="content-block">
      <div className="inner-content-wrap">
        <div className="create-workflow-container">{children}</div>
      </div>
    </div>
  );
}

function CreateWorkflow({ navToggle, profile, organizationCredits }) {
  const { state, dispatch } = useContext(WorkflowContext);
  const [blockOptions, setSettingsOptions] = useState(false);
  const [verifyActivation, setVerifyActivation] = useState(null);
  const [activationError, setActivationError] = useState(null);
  const { name: workflowName } = useParams();
  const { integration: integrationName } = useParams();
  const nameRef = useRef(null);
  useEffect(() => {
    getTemplates().then(({ data, statusCode }) => {
      if (statusCode == 200) {
        // dispatch({ type: actions.GET_TEMPLATES, payload: data.templates });
        const myTemplate = data.templates.find(
          (template) => template.type === workflowName.toLowerCase()
        );
        if (integrationName) {
          myTemplate.blocks = [
            {
              id: 1,
              name: integrationName,
              action: "integration-" + integrationName,
              type: "flow_action",
              options: { email: "" },
            },
          ];
        }
        if (myTemplate.type == "enrichment") {
          myTemplate.blocks = myTemplate.blocks.map((block) => {
            if (block.id == "1") {
              block.options.addLead = true;
            }
            return block;
          });
        }
        dispatch({
          type: actions.SELECTED_TEMPLATE,
          payload: myTemplate,
        });
      } else {
        dispatch({ type: actions.ERROR, payload: data.message });
      }
    });
  }, []);
  const handleCreateWorkflow = async (wkName) => {
    if (
      checkPermission({
        permissions: profile.permissions,
        name: "Workflow",
        action: "Edit",
      })
    ) {
      if (!wkName) {
        return nameRef.current.reportValidity();
      }
      const workflow = state.selectedTemplate;
      if (workflow.type == "linkedin") {
        workflow.blocks = workflow.blocks.map((block) => {
          if (block.action === "linkedin-message") {
            if (!block.options.message) {
              block.active = false;
            }
          }
          return block;
        });
      }
      workflow.name = wkName;
      const { data, statusCode } = await createWorkflow(workflow);
      if (statusCode === 200) {
        setVerifyActivation(data.workflow);
      }
    } else {
      toast.error(<FormattedMessage id={"permissions.noAccess"} />);
    }
  };
  const handleWorkflowActivation = async () => {
    const { data, statusCode } = await updateWorkflowActivationState({
      _id: verifyActivation._id,
      active: true,
    });
    if (statusCode == 200) {
      setVerifyActivation(null);
      window.location = "/workflow";
    } else {
      setActivationError(data.message);
    }
  };
  const handleCancelActivation = () => {
    setVerifyActivation(false);
    window.location = "/workflow";
  };
  const handleRefreshAndCloseSettings = (save) => {
    setSettingsOptions(false);
  };
  const SELECTED_TEMPLATE = {
    linkedin: (
      <LinkedinTemplate
        blockOptions={blockOptions}
        handleSettingsToggle={(blockOptions) =>
          setSettingsOptions(blockOptions)
        }
        template={state.selectedTemplate}
        activeBlockId={blockOptions.id}
        closeSettingsToggle={handleRefreshAndCloseSettings}
      />
    ),
    enrichment: (
      <EnrichementTemplate
        blockOptions={blockOptions}
        handleSettingsToggle={(blockOptions) =>
          setSettingsOptions(blockOptions)
        }
        template={state.selectedTemplate}
        activeBlockId={blockOptions.id}
      />
    ),
    integration: (
      <IntegrationTemplate
        blockOptions={blockOptions}
        handleSettingsToggle={(blockOptions) =>
          setSettingsOptions(blockOptions)
        }
        template={state.selectedTemplate}
        integrationName={integrationName}
        activeBlockId={blockOptions.id}
      />
    ),
  };
  if (!state.selectedTemplate) {
    return <PreLoader />;
  }

  return (
    <Col
      md={"10"}
      className={"content-wrap tab-pane  " + (navToggle ? "expand" : "")}
    >
      <WorkflowTreeWrapper>
        <MenuBar createWorkflow={handleCreateWorkflow} ref={nameRef} />
        <div className="create-workflow-outer">
          <div className="create-workflow-tree-block ">
            <div className="create-inner-tree-block">
              {workflowName == "linkedin" && (
                <span
                  className={"beta-badge"}
                  style={{
                    position: "absolute",
                    top: 10,
                    left: 10,
                    width: "max-content",
                    fontSize: 14,
                    zIndex: 100,
                  }}
                >
                  BETA
                </span>
              )}

              {/*
              <ZoomButtons />
*/}
              {SELECTED_TEMPLATE[workflowName.toLowerCase()]}
            </div>
            <TemplateSettings
              handleSettingsToggle={handleRefreshAndCloseSettings}
              blockOptions={blockOptions}
              profile={profile}
              organizationCredits={organizationCredits}
              isCreate
            />
          </div>
        </div>
      </WorkflowTreeWrapper>
      {verifyActivation && (
        <ModalMessage
          title={
            <>
              <FormattedMessage id={"activate"} /> {verifyActivation.name}{" "}
            </>
          }
          textElement={
            <>
              <p>
                <strong>
                  <FormattedMessage
                    id={"workflow.byDefaultTheWorkflowIsDisabled"}
                  />
                </strong>
                <br />
                <FormattedMessage id={"workflow.pleaseClickToConfirm"} />
              </p>
              {activationError == "Permission denied" && (
                <div style={{ textAlign: "center", color: "darkred" }}>
                  <div>
                    <FormattedMessage id={"permissions.upgradePlan"} />
                  </div>
                  <a
                    className={"btn btn1"}
                    style={{ marginTop: 10 }}
                    href={"/billing"}
                  >
                    <FormattedMessage id={"organization.upgradePan"} />
                  </a>
                </div>
              )}
            </>
          }
          action={<FormattedMessage id={"confirm"} />}
          toggle={verifyActivation}
          setToggle={handleCancelActivation}
          handleAction={handleWorkflowActivation}
          error={activationError !== "Permission denied" && activationError}
        />
      )}
      <ToastContainer position="bottom-right" style={{ top: 100 }} />
    </Col>
  );
}

export default CreateWorkflow;
